import { render, staticRenderFns } from "./dialogList2.vue?vue&type=template&id=432ef5e1&scoped=true&"
import script from "./dialogList2.vue?vue&type=script&lang=ts&"
export * from "./dialogList2.vue?vue&type=script&lang=ts&"
import style0 from "./dialogList2.vue?vue&type=style&index=0&id=432ef5e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ef5e1",
  null
  
)

export default component.exports